import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';

import CircleIcon from './icons/circle_icon';

export default class KeypadButton extends React.Component {
  constructor(props) {
    super(props);
    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
  }
  render() {
    return (
      <CircleIcon viewBox="0 0 25 25" {...this.props}>
        <g id="iconKeypad">
          <path d="M8.15 9.694h2.125v-2.2H8.15M11.398 9.694h2.125v-2.2h-2.125M14.646 9.694h2.125v-2.2h-2.124M8.15 13.477h2.125v-2.2H8.15M11.398 13.477h2.125v-2.2h-2.125M14.646 13.477h2.13v-2.2h-2.13M8.15 17.26h2.125v-2.2H8.15M11.398 17.26h2.125v-2.2h-2.125M14.646 17.26h2.125v-2.2h-2.124" />
        </g>
      </CircleIcon>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/phone_controls/buttons/keypad_button.jsx